import React from "react";
import { withStyles } from '@material-ui/core/styles';
import {  injectIntl } from "react-intl";
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import Checkbox from '@material-ui/core/Checkbox';

 import { Link,Redirect } from "react-router-dom";
																										

import clsx from 'clsx';
 import { updateMaster, getStatus,getMaster,getJobStatus,getOrderStatus
//  ,getRolesByAccount 
} from "../../crud/auth.crud";


const useStyles = withStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));




const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
   formControl: {
    //margin: theme.spacing(3),
  },
};


class EditRole extends React.Component {

state = {
    	patient:{},
    	template:{},
    	menu: false,
    	
    redirect:false,
    statuses:[],
    tasktypes:[],
    role:{permissions:[]},
	tag:'',
  	}
	
constructor(props)
{
  super(props);
  let template={fieldGroups:[{fields:[{}]}]};
  let mMenu = [
	{
		"title" : "Dashboard",
		"root" : true,
		"icon" : "flaticon2-browser-2",
		"page" : "dashboard",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}, 
	{
		"title" : "Master",
		"root" : true,
		"icon" : "flaticon2-gear",
		"page" : "patient",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot",
		"submenu":[]
	},
	{
		"title" : "Calendar",
		"root" : true,
		"icon" : "flaticon2-calendar-2",
		"page" : "calendar",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}, 
	{
		"title" : "Order Status",
		"root" : true,
		"icon" : "flaticon2-supermarket",
		"page" : "orders",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}, 
	{
		"title" : "My To Do",
		"root" : true,
		"icon" : "flaticon2-schedule",
		"page" : "schedule",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}, 

	{
		"title" : "My Patients",
		"root" : true,
		"icon" : "flaticon2-group",
		"page" : "patient",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}, 
	{
		"title" : "Digital Planning",
		"root" : true,
		"icon" : "flaticon2-paper-plane",
		"page" : "digitalplanning",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}, 
	{
		"title" : "Labs",
		"root" : true,
		"icon" : "flaticon2-drop",
		"page" : "lab",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}, 
	{
		"title" : "Specialist",
		"root" : true,
		"icon" : "flaticon2-user-outline-symbol",
		"page" : "vendor",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}, 
	{
		"title" : "New Patient",
		"root" : true,
		"icon" : "flaticon2-architecture-and-city",
		"page" : "createpatient",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}, 

	{
		"title" : "Referred Patient",
		"root" : true,
		"icon" : "flaticon2-group",
		"page" : "patient",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot",
		"submenu" : [ 
			{
				"title" : "View All",
				"bullet" : "dot",
				"page" : "patient"
			}
		]
	}, 

	 {
            "title" : "Reports",
            "root" : true,
            "icon" : "flaticon2-gear",
            "page" : "patient",
            "translate" : "MENU.DASHBOARD",
            "bullet" : "dot",
            "submenu" : [ 
                {
                    "title" : "Sales Insight",
                    "bullet" : "dot",
                    "page" : "salesreport"
                }, 
                {
                    "title" : "Order Summary",
                    "bullet" : "dot",
                    "page" : "salescompare"
                }, 
                {
                    "title" : "Wallet Comparison",
                    "bullet" : "dot",
                    "page" : "walletcompare"
                }
            ]
        }, 

	{
		"title" : "Vendors",
		"root" : true,
		"icon" : "flaticon2-user-outline-symbol",
		"page" : "vendor",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}, 

	{
		"title" : "My details",
		"root" : true,
		"icon" : "flaticon2-group",
		"page" : "patient",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}, 

	{
		"title" : "Help",
		"root" : true,
		"icon" : "flaticon2-help",
		"page" : "help",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	},
	{
		"title" : "Referrals",
		"root" : true,
		"icon" : "flaticon2-architecture-and-city",
		"page" : "referral",
		"translate" : "MENU.DASHBOARD",
		"bullet" : "dot"
	}
  ];
  let masterScreens =[
	{
		"title" : "Pending Approval",
		"bullet" : "dot",
		"page" : "approval"
	}, 
	{
		"title" : "Roles",
		"bullet" : "dot",
		"page" : "role"
	}, 
	{
		"title" : "Business Types",
		"bullet" : "dot",
		"page" : "businessentity"
	}, 
	
	{
		"title" : "Users",
		"bullet" : "dot",
		"page" : "user"
	}, 
	{
		"title" : "Accounts",
		"bullet" : "dot",
		"page" : "account"
	}, 
	{
		"title" : "Status",
		"bullet" : "dot",
		"page" : "status"
	}, 
	{
		"title" : "Account Status",
		"bullet" : "dot",
		"page" : "accstatus"
	}, 
	{
		"title" : "Digital Planning Status",
		"bullet" : "dot",
		"page" : "jobstatus"
	}, 
	{
		"title" : "Digital Planning Package",
		"bullet" : "dot",
		"page" : "jobservice"
	}, 
	{
		"title" : "Banner",
		"bullet" : "dot",
		"page" : "banner"
	}, 
	{
		"title" : "Order Placement",
		"bullet" : "dot",
		"page" : "summary"
	}, 
	{
		"title" : "Order Status",
		"bullet" : "dot",
		"page" : "orders"
	}, 
	{
		"title" : "Bulk Assign",
		"bullet" : "dot",
		"page" : "bulkupdate"
	},
	{
		"title" : "Subscription Tier",
		"bullet" : "dot",
		"page" : "accounttier"
	}, 
	{
		"title" : "Implant Type",
		"bullet" : "dot",
		"page" : "implanttype"
	}, 
	{
		"title" : "Procedure Type",
		"bullet" : "dot",
		"page" : "proceduretype"
	},
	{
		"title" : "Sales Insight",
		"bullet" : "dot",
		"page" : "salesinsight"
	},
	{
		"title" : "Wallet Comparison",
		"bullet" : "dot",
		"page" : "salescompare"
	}
];


  if(this.props.location.data != null)
  {
	let menu = [];
	this.props.location.data.role.menus.map((x)=>{
		if(x.title==="Master")
		{
			x.submenu.map((sm)=>(
				menu.push(sm.title)
			))
		}
		else
		{
			menu.push(x.title)
		}
	})

  	console.log("role::::",this.props.location.data.role);
  	this.state = {
      
      role:this.props.location.data.role,
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      
    	redirect:false,
    	statuses:[],
    	tasktypes:[],
		permissions:this.props.location.data.role.permissions,
		mMenu:mMenu,
		menu:menu,
		tag:this.props.location.data.role.tag!==undefined && this.props.location.data.role.tag!==null ?this.props.location.data.role.tag:'',
		masterScreens:masterScreens,
		jobstatus:[],
		orderstatus:[],
      
    };
  }
  else
  {
  		this.state = {
      
      role:{permissions:[]},
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      redirect:false,
      statuses:[],
      tasktypes:[],
	  mMenu:mMenu,
	  masterScreens:masterScreens,
      tag:'',
	  jobstatus:[],
	  orderstatus:[],
    };
  }
 
  
}

componentDidMount()
  {
    
    getStatus().then(response => response.data)
    .then((data) => {
      this.setState({ statuses: data })
      //console.log(this.state.users)
     })

	 getJobStatus().then(response => response.data)
	 .then((data) => {
	   this.setState({ jobstatus: data })
	   //console.log(this.state.users)
	  })

	  getOrderStatus().then(response => response.data)
	 .then((data) => {
	   this.setState({ orderstatus: data })
	   //console.log(this.state.users)
	  })

    getMaster("tasktype").then(response => response.data)
    .then((data) => {
      this.setState({ tasktypes: data })
      //console.log(this.state.users)
     })

  }


   renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={{pathname:"/role"}} />
    }
  }


submitForm = event => {
	const {...inputFields } = this.state;
	//console.log("inputfields:::::",inputFields);

	console.log("permissions:::::",inputFields.permissions);
	console.log("menu:::::",inputFields.menu);
	console.log("master menu:::::",inputFields.masterMenu);
	console.log("tag:::::",inputFields.tag);
	
	let menus = [];
	let tag = inputFields.tag;
	let permissions = inputFields.permissions;
	
	if(inputFields.menu !==undefined)
	{
		this.state.mMenu.map((m)=>{
			if(m.title === "Master")
			{
				let submenu=[];
				this.state.masterScreens.map((mm)=>{
					inputFields.menu.includes(mm.title) &&	submenu.push(mm)
					
				})
				m.submenu = submenu;
				if(m.submenu.length>0)
					menus.push(m);
			}
			else
			{
				inputFields.menu.includes(m.title) && menus.push(m)
				
			}
		})
	}

	console.log("final menus:::",menus);

	let mssterObj ={};
	if(tag ==="")
		mssterObj= {
			menu: menus,
			permissions: permissions,
			tag:null
		}
	else
	mssterObj= {
		menu: menus,
		permissions: permissions,
		tag:tag
		
	}

    this.setState({loading:false});
	updateMaster("role",this.state.role.roleId,mssterObj)
                      .then(resp => {
                       
                       
                       this.setState({status:true,
                        statusMessage:'Permissions updated successfully',
                        alertType:'alert-success',loading:false,redirect:true});
                         window.scrollTo(0,0);
                       
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                      

	event.preventDefault();
}

handleChange = event => {
	this.setState({
		[event.currentTarget.name] : event.currentTarget.value
	})
}

handleCheckBoxChange = event => {

	//console.log(event.currentTarget.name + "---"+ event.currentTarget.value);
	//console.log(event);
	let chk = this.state[event.currentTarget.name];

	let temp =[];
	//console.log(chk);
	let chkvalue=[];
	if(chk!=null )
	{

		
		/*chk.map((x)=>(
			temp.push(JSON.stringify(x))
		))
		if(event.currentTarget.name.includes("menu"))
		{
			let index = temp.findIndex(x=> JSON.stringify(x) ===JSON.stringify(event.currentTarget.value))
			console.log("index::::",index);
			if(index===-1)
			{
				
				chk.push(JSON.parse(event.currentTarget.value));
				
			}
			else
			{
				chk.splice(index,1);
			}
		}
		else
		{
			let index = temp.findIndex(x=> x ===JSON.stringify(event.currentTarget.value))
			console.log("index::::",index);
			if(index===-1)
			{
				chk.push(event.currentTarget.value);
			}
			else
			{
				chk.splice(index,1);
			}
		}
		*/
		if(event.currentTarget.name!=="tag")
		{
		let index = chk.findIndex(x=> x ==event.currentTarget.value)
			//console.log("index::::",index);
			if(index===-1)
			{
				chk.push(event.currentTarget.value);
			}
			else
			{
				chk.splice(index,1);
			}
		}
		else
		{
			chk = chk === event.currentTarget.value ?  '': event.currentTarget.value;
		}
	
	}
	else
	{
		chk = [event.currentTarget.value];
	}
	this.setState({
		[event.currentTarget.name] : chk
	})
}

	render()
	{
		//console.log("role::::",this.state.role);
		
    	return (
    		<>
    			{this.renderRedirect()}
    			 {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}

    			

    			<form onSubmit={this.submitForm}>
    				
	    			<div className="row">
	    				<div className="col-lg-12">
	    					<div className="kt-portlet">
		    					<div className="kt-portlet__head">
									<div className="kt-portlet__head-label">
										<h3 className="kt-portlet__head-title">
											Role
										</h3>
									</div>
								</div>
			    				<div className="kt-portlet__body">
					        				
					        								<div className="row">
					        									<div className="col-12">
					        							
							        								<FormControl component="fieldset">
																        <FormLabel component="legend">{'Dashboard'}</FormLabel>
																        <FormGroup>
																         
																          <FormControlLabel
																            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'WIDGETADMIN'} name={'permissions'} checked={this.state.role.permissions.includes('WIDGETADMIN')} />}
																            label={'ADMIN'}
																          />

																          <FormControlLabel
																            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'WIDGETCALENDAR'} name={'permissions'} checked={this.state.role.permissions.includes('WIDGETCALENDAR')} />}
																            label={'Calendar'}
																          />

																          <FormControlLabel
																            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'WIDGETSTATUS'} name={'permissions'}  checked={this.state.role.permissions.includes('WIDGETSTATUS')} />}
																            label={'Status'}
																          />

																          <FormControlLabel
																            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'WIDGETUSAGE'} name={'permissions'} checked={this.state.role.permissions.includes('WIDGETUSAGE')} />}
																            label={'Usage'}
																          />
																			 </FormGroup>
																     	</FormControl>

														     			<FormControl component="fieldset">
																        <FormLabel component="legend">{'Todo Actions'}</FormLabel>
																        <FormGroup>
																         
																          <FormControlLabel
																            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'CREATE:TASK'} name={'permissions'} checked={this.state.role.permissions.includes('CREATE:TASK')} />}
																            label={'CREATE'}
																          />

																          <FormControlLabel
																            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEW:TASK'} name={'permissions'} checked={this.state.role.permissions.includes('VIEW:TASK')} />}
																            label={'VIEW'}
																          />

																          <FormControlLabel
																            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'DELETE:TASK'} name={'permissions'} checked={this.state.role.permissions.includes('DELETE:TASK')}/>}
																            label={'DELETE'}
																          />

																          <FormControlLabel
																            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'EDIT:TASK'} name={'permissions'} checked={this.state.role.permissions.includes('EDIT:TASK')}/>}
																            label={'EDIT'}
																          />

																          <FormControlLabel
																            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'CREATE:BULKASSIGNMENT'} name={'permissions'} checked={this.state.role.permissions.includes('CREATE:BULKASSIGNMENT')}/>}
																            label={'Bulk Todo Assigment'}
																          />
																			 </FormGroup>
																 	    </FormControl>

												
					        										<FormControl component="fieldset">
														        <FormLabel component="legend">{'User'}</FormLabel>
														        <FormGroup>
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'CREATE:USER'} name={'permissions'} checked={this.state.role.permissions.includes('CREATE:USER')} />}
														            label={'CREATE'}
														          />
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEW:USER'} name={'permissions'} checked={this.state.role.permissions.includes('VIEW:USER')}/>}
														            label={'VIEW'}
														          />
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'DELETE:USER'} name={'permissions'} checked={this.state.role.permissions.includes('DELETE:USER')}/>}
														            label={'DELETE'}
														          />
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'EDIT:USER'} name={'permissions'} checked={this.state.role.permissions.includes('EDIT:USER')}/>}
														            label={'EDIT'}
														          />
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'ACTIVATE:USER'} name={'permissions'} checked={this.state.role.permissions.includes('ACTIVATE:USER')}/>}
														            label={'ACTIVATE'}
														          />
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'SETPASSWORD:USER'} name={'permissions'} checked={this.state.role.permissions.includes('SETPASSWORD:USER')}/>}
														            label={'SET PASSWORD'}
														          />
																	 </FormGroup>
														     </FormControl>
					        				
					        						<FormControl component="fieldset" variant="outlined">
														        <FormLabel component="legend">{'Patient'}</FormLabel>
														        <FormGroup>
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'CREATE:PATIENT'} name={'permissions'} checked={this.state.role.permissions.includes('CREATE:PATIENT')} />}
														            label={'CREATE'}
														          />
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEW:PATIENT'} name={'permissions'} checked={this.state.role.permissions.includes('VIEW:PATIENT')} />}
														            label={'VIEW'}
														          />
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'DELETE:PATIENT'} name={'permissions'} checked={this.state.role.permissions.includes('DELETE:PATIENT')} />}
														            label={'DELETE'}
														          />
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'EDIT:PATIENT'} name={'permissions'}  checked={this.state.role.permissions.includes('EDIT:PATIENT')} />}
														            label={'EDIT'}
														          />
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEWALLPROJECTS'} name={'permissions'} checked={this.state.role.permissions.includes('VIEWALLPROJECTS')} />}
														            label={'VIEW ALL PATIENTS'}
														          />
																	 </FormGroup>
														     </FormControl>
															 <FormControl component="fieldset" variant="outlined">
														        <FormLabel component="legend">{'Digital Planning'}</FormLabel>
														        <FormGroup>
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'CREATE:JOB'} name={'permissions'} checked={this.state.role.permissions.includes('CREATE:JOB')} />}
														            label={'CREATE'}
														          />
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEW:JOB'} name={'permissions'} checked={this.state.role.permissions.includes('VIEW:JOB')} />}
														            label={'VIEW'}
														          />			

																   <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'CREATE:JOBINVOICE'} name={'permissions'} checked={this.state.role.permissions.includes('CREATE:JOBINVOICE')} />}
														            label={'GENERATE INVOICE'}
														          />

<FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEW:JOBINVOICE'} name={'permissions'} checked={this.state.role.permissions.includes('VIEW:JOBINVOICE')} />}
														            label={'VIEW INVOICE'}
														          />

																   <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'PAY:JOBINVOICE'} name={'permissions'} checked={this.state.role.permissions.includes('PAY:JOBINVOICE')} />}
														            label={'PAY INVOICE'}
														          />

																 


														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEWALLJOBS'} name={'permissions'} checked={this.state.role.permissions.includes('VIEWALLJOBS')} />}
														            label={'VIEW ALL JOBS'}
														          />



																  
																  <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEWASSIGNEDJOBS'} name={'permissions'} checked={this.state.role.permissions.includes('VIEWASSIGNEDJOBS')} />}
														            label={'VIEW ASSIGNED JOBS'}
														          />

																   <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'JOBNOTIFY'} name={'permissions'} checked={this.state.role.permissions.includes('JOBNOTIFY')} />}
														            label={'NOTIFICATION'}
														          />
																	 </FormGroup>
														     </FormControl>
															  <FormControl component="fieldset" variant="outlined">
														        <FormLabel component="legend">{'Order'}</FormLabel>
														        <FormGroup>
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'CREATE:ORDER'} name={'permissions'} checked={this.state.role.permissions.includes('CREATE:ORDER')} />}
														            label={'CREATE'}
														          />
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEW:ORDER'} name={'permissions'} checked={this.state.role.permissions.includes('VIEW:ORDER')} />}
														            label={'VIEW'}
														          />			

																   <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'CREATE:ORDERINVOICE'} name={'permissions'} checked={this.state.role.permissions.includes('CREATE:ORDERINVOICE')} />}
														            label={'GENERATE INVOICE'}
														          />

<FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEW:ORDERINVOICE'} name={'permissions'} checked={this.state.role.permissions.includes('VIEW:ORDERINVOICE')} />}
														            label={'VIEW INVOICE'}
														          />

																   <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'PAY:ORDERINVOICE'} name={'permissions'} checked={this.state.role.permissions.includes('PAY:ORDERINVOICE')} />}
														            label={'PAY INVOICE'}
														          />

																 


														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEWALLORDERS'} name={'permissions'} checked={this.state.role.permissions.includes('VIEWALLORDERS')} />}
														            label={'VIEW ALL ORDERS'}
														          />



																  
																  <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'VIEWASSIGNEDORDERS'} name={'permissions'} checked={this.state.role.permissions.includes('VIEWASSIGNEDORDERS')} />}
														            label={'VIEW ASSIGNED ORDERS'}
														          />

																   <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'ORDERNOTIFY'} name={'permissions'} checked={this.state.role.permissions.includes('ORDERNOTIFY')} />}
														            label={'NOTIFICATION'}
														          />
																	 </FormGroup>
														     </FormControl>
					        				
					        						
					        					</div>
					        				</div>
					        						
									           
					        	</div>
				        	</div>
			        	</div>
		        	</div>

		        <div className="row">
	    				<div className="col-lg-12">
	    					<div className="kt-portlet">
		    					<div className="kt-portlet__head">
									<div className="kt-portlet__head-label">
										<h3 className="kt-portlet__head-title">
											Status Permissions
										</h3>
									</div>
								</div>
			    				<div className="kt-portlet__body">
			    					<FormControl component="fieldset">
														        <FormLabel component="legend">{'Allowed status for Todo update'}</FormLabel>
														        <FormGroup row={true}>

														        	 {this.state.statuses!==null && this.state.statuses.map((status) => (
														          <FormControlLabel key={status.id}
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'ALLOWEDSTATUS:'+status.statusKey} name={'permissions'} checked={this.state.role.permissions.includes('ALLOWEDSTATUS:'+status.statusKey)} />}
														            label={status.statusName}
														          />
														          ))}
														          
																	 </FormGroup>
														     </FormControl>
			    				</div>
			    			</div>
			    		</div>
			    	</div>

			    	<div className="row">
	    				<div className="col-lg-12">
	    					<div className="kt-portlet">
		    					<div className="kt-portlet__head">
									<div className="kt-portlet__head-label">
										<h3 className="kt-portlet__head-title">
											Todo Types Permissions
										</h3>
									</div>
								</div>
			    				<div className="kt-portlet__body">
			    					<FormControl component="fieldset">
														        <FormLabel component="legend">{'Allowed Types for Todo update'}</FormLabel>
														        <FormGroup row={true}>

														        	 {this.state.tasktypes!==null && this.state.tasktypes.map((tt) => (
														          <FormControlLabel key={tt.id}
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'ALLOWEDTYPE:'+tt.taskTypeId} name={'permissions'} checked={this.state.role.permissions.includes('ALLOWEDTYPE:'+tt.taskTypeId)} />}
														            label={tt.taskTypeName}
														          />
														          ))}
														          
																	 </FormGroup>
														     </FormControl>
			    				</div>
			    			</div>
			    		</div>
			    	</div>

					<div className="row">
	    				<div className="col-lg-12">
	    					<div className="kt-portlet">
		    					<div className="kt-portlet__head">
									<div className="kt-portlet__head-label">
										<h3 className="kt-portlet__head-title">
											Digital Planning Status Permissions
										</h3>
									</div>
								</div>
			    				<div className="kt-portlet__body">
			    					<FormControl component="fieldset">
														        <FormLabel component="legend">{'Allowed status for digital planning update'}</FormLabel>
														        <FormGroup row={true}>

														        	 {this.state.jobstatus!==null && this.state.jobstatus.map((status) => (
														          <FormControlLabel key={status.id}
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'ALLOWEDJOBSTATUS:'+status.jobStatusId} name={'permissions'} checked={this.state.role.permissions.includes('ALLOWEDJOBSTATUS:'+status.jobStatusId)} />}
														            label={status.jobStatusName}
														          />
														          ))}
														          
																	 </FormGroup>
														     </FormControl>
			    				</div>
			    			</div>
			    		</div>
			    	</div>
	       		
					<div className="row">
	    				<div className="col-lg-12">
	    					<div className="kt-portlet">
		    					<div className="kt-portlet__head">
									<div className="kt-portlet__head-label">
										<h3 className="kt-portlet__head-title">
											Order Status Permissions
										</h3>
									</div>
								</div>
			    				<div className="kt-portlet__body">
			    					<FormControl component="fieldset">
														        <FormLabel component="legend">{'Allowed status for order update'}</FormLabel>
														        <FormGroup row={true}>

														        	 {this.state.orderstatus!==null && this.state.orderstatus.map((ods,index) => (
														          <FormControlLabel key={'od'+index}
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'ALLOWEDORDERSTATUS:'+ods.orderStatusId} name={'permissions'} checked={this.state.role.permissions.includes('ALLOWEDORERSTATUS:'+ods.orderStatusId)} />}
														            label={ods.orderStatusName}
														          />
														          ))}
														          
																	 </FormGroup>
														     </FormControl>
			    				</div>
			    			</div>
			    		</div>
			    	</div>
	       		<div className="row">
	    				<div className="col-lg-12">
	    					<div className="kt-portlet">
		    					<div className="kt-portlet__head">
									<div className="kt-portlet__head-label">
										<h3 className="kt-portlet__head-title">
											Screen Permissions
										</h3>
									</div>
								</div>
			    				<div className="kt-portlet__body">
			    					<FormControl component="fieldset" variant="outlined">
														        <FormLabel component="legend">{'Screens'}</FormLabel>
														        <FormGroup row={true}>
																{this.state.mMenu!==undefined && this.state.mMenu!==null && this.state.menu!==undefined && this.state.menu!==null && this.state.mMenu.map((ss,index) => (
														        
														          <FormControlLabel key={ss.index}
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={ss.title} name={'menu'} checked={this.state.menu.includes(ss.title)}/>}
														            label={ss.title}
														          />
																))}
																	 </FormGroup>
														     </FormControl>
			    				</div>
			    			</div>
			    			</div>
			    	</div>


	       		<div className="row">
	    				<div className="col-lg-12">
	    					<div className="kt-portlet">
		    					<div className="kt-portlet__head">
									<div className="kt-portlet__head-label">
										<h3 className="kt-portlet__head-title">
											Master Permissions
										</h3>
									</div>
								</div>
			    				<div className="kt-portlet__body">
			    					<FormControl component="fieldset" variant="outlined">
														        <FormLabel component="legend">{'Master Screens'}</FormLabel>
														        <FormGroup row={true}>
																{this.state.masterScreens!==undefined && this.state.masterScreens!==null && this.state.menu !==undefined && this.state.menu !==null && this.state.masterScreens.map((ms,index) => (
														          <FormControlLabel key={index}
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={ms.title} name={'menu'} checked={this.state.menu.includes(ms.title)}  />}
														            label={ms.title}
														          />
																))}
														          

																	 </FormGroup>
														     </FormControl>
			    				</div>
			    			</div>
			    		</div>
			    	</div>

			    	<div className="row">
	    				<div className="col-lg-12">
	    					<div className="kt-portlet">
		    					<div className="kt-portlet__head">
									<div className="kt-portlet__head-label">
										<h3 className="kt-portlet__head-title">
											Tag
										</h3>
									</div>
								</div>
			    				<div className="kt-portlet__body">

					        								<FormControl component="fieldset">
														        <FormLabel component="legend">{'File categorization by role tags'}</FormLabel>
														        <FormGroup row={true}>
																
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={'Referral'} name={'tag'} checked={this.state.tag.includes('Referral')} />}
														            label={'Referral'}
														          />
																  

														         
																	 </FormGroup>
														     </FormControl>
			    				</div>
			    			</div>
			    		</div>
			    	</div>

	        	<div className="row">
	        		<div className="col-lg-12">


                        <button
                          type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                          >
                           Update
                        </button> &nbsp; &nbsp;
                   		<Link to={{pathname:'/role', data:''}}>Back</Link>
	        		</div>
	        	</div>

	        	</form>
    		</>
    	);
	}	
}   

export default injectIntl(withStyles(styles)(EditRole));